// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nn-9";
export var arrowButtonContainer = "_nn-5";
export var arrowButtonIcon = "_nn-6";
export var carouselArrowButton = "_nn-2";
export var carouselElementContainer = "_nn-1";
export var currentSlide = "_nn-8";
export var left = "_nn-3";
export var otherSlide = "_nn-a";
export var productCarouselContainer = "_nn-0";
export var right = "_nn-4";
export var sliderOverflow = "_nn-7";